import { createFileRoute } from "@tanstack/react-router";

import { AdminQuality } from "@/features/admin";

/**
 * Admin Quality — wire path ``/admin/quality``.
 *
 * v1 reference: ``app/admin-v2/components/pages/QualityPage.tsx`` (95 LoC).
 * BE: ``GET /admin/v2/quality`` (``admin_v2.py:465``).
 */
export const Route = createFileRoute("/_authed/_modal/admin/quality")({
  component: AdminQuality,
});
